import React, { useState } from 'react';
import { MultiSelect } from 'carbon-components-react';
import funcTranslateHelper from '../../../../i18next/funcTranslateHelper';

const MultiSelectFormControl = (props) => {
  const items = props.schema.items.enumValues.map(
    (option, i) => ({ id: props.schema.items.enum[i], text: option })
  );

  // Set selected elements if are passed through formData
  let initialValues = [];
  if (props.formData) initialValues = items.filter(item => props.formData.find(element => element === item.id));
  const [selectedItems, setSelectedItems] = useState(initialValues);

  const onChange = (event) => {
    setSelectedItems(event.selectedItems);
    props.onChange(event.selectedItems.map(item => item.id));
  };

  return (
    <MultiSelect.Filterable
      id={props.idSchema.$id}
      useTitleInItem={false}
      titleText={props.schema.title}
      placeholder={funcTranslateHelper('Builder:form:chooseOption')}
      invalid={false}
      invalidText={funcTranslateHelper('Builder:form:invalid')}
      light
      onChange={onChange}
      items={items}
      initialSelectedItems={selectedItems}
      itemToString={item => (item ? item.text : '')}
    />
  );
};

export default MultiSelectFormControl;
